import Content from "../../../../layout/Content";
import JobForm from "@serie3/freelancesplaceapi/Form/Project/Job/JobForm";
import { useFormik } from "formik";
import { useEffect, useState, useRef } from "react";
import TextField from "../../../../layout/Form/Fields/TextField";
import TextArea from "../../../../layout/Form/Fields/TextArea";
import ReferencedInputAndSubmit from "../../../../layout/Form/Fields/ReferencedInputAndSubmit";
import Checkbox from "../../../../layout/Form/Fields/Checkbox";
import Card from "../../../../layout/Cards/Card";
import { useParams } from "react-router-dom";
import crudApi from "@serie3/common/api/crudApi";
import JobConfig from "@serie3/freelancesplaceapi/Config/Projects/JobConfig";
import DateField from "../../../../layout/Form/Fields/DateField";
import TagLikeHandler from "@serie3/freelancesplaceapi/Form/shared/TagLikeHandler";
import Tag from "../../../../layout/Buttons/Tag";
import LanguageForm from "../../../../layout/Form/LanguageForm";
import AddLanguageButton from "../../../../layout/Buttons/AddLanguageButton";
import CompleteDropdown from "../../../../layout/Dropdowns/CompleteDropdown";
import JobHeader from "./JobHeader";
import Freelancers from "./Freelancers";
import NumberField from "../../../../layout/Form/Fields/NumberField";
import Job from "@serie3/freelancesplaceapi/Domain/Projects/Job";
import CustomerModal from "../../crm/Shared/CustomerModal";
import Address from "../../../../layout/Common/Address";
import ContactData from "../../../../layout/Common/ContactData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faGlobe, faAddressCard, faUser } from "@fortawesome/free-solid-svg-icons";

const Edit = () => {
  const [editJob, setEditJob] = useState();
  const [keySkills, setKeySkills] = useState([]);
  const [niceToHaveSkills, setNiceToHaveSkills] = useState([]);
  const [tasks, setTaks] = useState([]);
  const [weOffer, setWeOffer] = useState([]);
  const [showLanguageForm, setShowLanguageForm] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [editLanguage, setEditLanguage] = useState();
  const [updateFreelancers, setUpdateFreelancers] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [contactData, setContactData] = useState();
  const [customerData, setCustomerData] = useState();
  const [contactFunction, setContactFunction] = useState();

  const jobForm = JobForm.createJobForm(setLanguages);
  const formik = useFormik(jobForm);
  const { id } = useParams();
  const skillsRef = useRef(null);
  const niceSkillsRef = useRef(null);
  const tasksRef = useRef(null);
  const weOfferRef = useRef(null);

  useEffect(() => {
    const loadData = async (id) => {
      const job = await crudApi.show(JobConfig.endpoints.show, id);
      setEditJob(job);
      setKeySkills(job.key_skills);
      setNiceToHaveSkills(job.other_skills);
      setTaks(job.to_do);
      setWeOffer(job.we_offer);
      setLanguages([...job.languages]);
      formik.setValues(JobForm.setEditData(job));

      let customer = job.person ? job.person : job.customer ? job.customer : null;
      setContactData(customer);
      let contactData = job.client_person ? job.client_person : job.client_customer ? job.client_customer : null;
      setCustomerData(contactData);
    };
    loadData(id);
  }, [id]);

  const saveAsDraft = (e) => {
    formik.setFieldValue("public", false);
    formik.setFieldValue("draft", true);
    formik.handleSubmit(e);
  };

  const save = (e) => {
    formik.setFieldValue("public", true);
    formik.setFieldValue("draft", false);
    formik.handleSubmit(e);
  };

  const addElement = (refName, valueName) => {
    TagLikeHandler.addElement(formik, refName, valueName);
    setUpdateFreelancers(!updateFreelancers);
  };

  const deleteElement = (element, valueName, setData) => {
    TagLikeHandler.deleteElement(element, valueName, setData, formik);
    setUpdateFreelancers(!updateFreelancers);
  };

  const deleteLanguage = (language) => {
    TagLikeHandler.deleteElement(language, "languages", setLanguages, formik);
  };

  const updateContact = async (contact) => {
    const response = await Job.updateContact(formik.values, contact);
    if (response.status === 200) {
      const job = response.data;
      setContactData(job.person ? job.person : job.customer ? job.customer : null);
    }
  };

  const updateCustomer = async (contact) => {
    const response = await Job.updateCustomer(formik.values, contact);
    if (response.status === 200) {
      const job = response.data;
      setCustomerData(job.client_person ? job.client_person : job.client_customer ? job.client_customer : null);
    }
  };

  const contactUpdateWrapper = (contact) => {
    if (contactFunction === "contact") updateContact(contact);
    if (contactFunction === "customer") updateCustomer(contact);
  };

  const pickButton = (label, icon, onClick) => (
    <button onClick={onClick} style={{
      display: "inline-flex", alignItems: "center", gap: "6px",
      padding: "6px 14px", background: "#e8f0fe", color: "#1a73e8",
      border: "none", borderRadius: "8px", fontWeight: 600,
      fontSize: "0.82rem", cursor: "pointer",
    }}>
      <FontAwesomeIcon icon={icon} /> {label}
    </button>
  );

  const SaveButtons = () => (
    <div style={{ display: "inline-flex", gap: "8px" }}>
      <button onClick={saveAsDraft} style={{
        display: "inline-flex", alignItems: "center", gap: "7px",
        padding: "8px 16px", background: "#f5f5f5", color: "#424242",
        border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "0.88rem", cursor: "pointer",
      }}>
        <FontAwesomeIcon icon={faFloppyDisk} /> Save as Draft
      </button>
      <button onClick={save} style={{
        display: "inline-flex", alignItems: "center", gap: "7px",
        padding: "8px 18px", background: "#e65100", color: "#fff",
        border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "0.88rem", cursor: "pointer",
        boxShadow: "0 2px 8px rgba(230,81,0,0.25)",
      }}>
        <FontAwesomeIcon icon={faGlobe} /> Publish
      </button>
    </div>
  );

  const LanguageButton = () => (
    <AddLanguageButton
      formik={formik}
      setEditLanguage={setEditLanguage}
      setShowLanguageForm={setShowLanguageForm}
    />
  );

  const thStyle = {
    padding: "9px 12px", fontSize: "0.7rem", fontWeight: 700,
    textTransform: "uppercase", letterSpacing: "0.08em",
    color: "#9e9e9e", background: "#f8f9fb",
    borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: "10px 12px", verticalAlign: "middle",
    borderBottom: "1px solid #f5f5f5", fontSize: "0.88rem", color: "#424242",
  };

  return editJob ? (
    <>
      <CustomerModal
        show={showCustomerModal}
        setShow={setShowCustomerModal}
        updateContact={contactUpdateWrapper}
      />
      <LanguageForm
        showEdit={showLanguageForm}
        setShowEdit={setShowLanguageForm}
        dataList={formik.values.languages}
        editLanguage={editLanguage}
        formik={formik}
        setDataList={setLanguages}
      />
      <JobHeader />
      <Content AdditionalButtons={SaveButtons}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: "20px", alignItems: "start" }}>

          {/* Main column */}
          <div>
            <Card title="Basics">
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                <TextField formik={formik} label="Job title" valueName="jobtitle" />
                <TextField formik={formik} label="Contract Type" valueName="contract_type" />
                <Checkbox formik={formik} label="On Site" valueName="on_site" />
                <TextArea formik={formik} label="Description" valueName="description" />
              </div>
            </Card>

            <Card title="Contact Data" CardTools={() => pickButton("Pick Contact", faAddressCard, () => { setContactFunction("contact"); setShowCustomerModal(true); })}>
              {contactData ? (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                  <Address contact={contactData} />
                  <ContactData contact={contactData} />
                </div>
              ) : (
                <div style={{ color: "#9e9e9e", fontSize: "0.88rem" }}>No contact selected.</div>
              )}
            </Card>

            <Card title="Customer" CardTools={() => pickButton("Pick Customer", faUser, () => { setContactFunction("customer"); setShowCustomerModal(true); })}>
              {customerData ? (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                  <Address contact={customerData} />
                  <ContactData contact={customerData} />
                </div>
              ) : (
                <div style={{ color: "#9e9e9e", fontSize: "0.88rem" }}>No customer selected.</div>
              )}
            </Card>

            <Card title="Dates">
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
                <DateField formik={formik} label="Start" valueName="start" />
                <DateField formik={formik} label="End" valueName="end" />
                <DateField formik={formik} label="Publish from" valueName="publish_from" />
                <DateField formik={formik} label="Publish to" valueName="publish_to" />
              </div>
            </Card>

            <Card title="Rates and Times">
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
                <NumberField formik={formik} label="Total Hours" valueName="max_hours" />
                <NumberField formik={formik} label="Weekly Hours" valueName="max_hours_per_week" />
                <NumberField formik={formik} label="Max Hourly Rate" valueName="max_hourly_rate" />
                <NumberField formik={formik} label="Max Daily Rate" valueName="max_daily_rate" />
              </div>
            </Card>

            <Card title="Must have Skills">
              <ReferencedInputAndSubmit namedReference={skillsRef} onClick={() => addElement(skillsRef, "key_skills")} />
              <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {keySkills.map((keySkill, index) => (
                  <Tag key={index} keySkill={keySkill} content={keySkill.name} deleteFunction={() => deleteElement(keySkill, "key_skills", setKeySkills)} />
                ))}
              </div>
            </Card>

            <Card title="Languages needed" CardTools={LanguageButton}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={thStyle}>Language</th>
                    <th style={{ ...thStyle, textAlign: "right" }}>Level</th>
                    <th style={{ ...thStyle, width: "40px" }} />
                  </tr>
                </thead>
                <tbody>
                  {languages && languages.map((language, index) => (
                    <tr key={index}>
                      <td style={tdStyle}>{language.name}</td>
                      <td style={{ ...tdStyle, textAlign: "right" }}>
                        <span style={{
                          display: "inline-block", padding: "2px 10px",
                          background: "#e8f0fe", color: "#1a73e8",
                          borderRadius: "20px", fontSize: "0.8rem", fontWeight: 600,
                        }}>
                          {language.level}%
                        </span>
                      </td>
                      <td style={{ ...tdStyle, padding: "0 8px" }}>
                        <CompleteDropdown
                          deleteAction={() => deleteLanguage(language)}
                          editAction={() => { setEditLanguage(language); setShowLanguageForm(true); }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>

            <Card title="Nice to have Skills">
              <ReferencedInputAndSubmit namedReference={niceSkillsRef} onClick={() => addElement(niceSkillsRef, "other_skills")} />
              <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {niceToHaveSkills.map((niceSkill, index) => (
                  <Tag key={index} item={niceSkill} content={niceSkill.name} deleteFunction={() => deleteElement(niceSkill, "other_skills", setNiceToHaveSkills)} />
                ))}
              </div>
            </Card>

            <Card title="Your Job">
              <ReferencedInputAndSubmit namedReference={tasksRef} onClick={() => addElement(tasksRef, "to_do")} />
              <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {tasks.map((task, index) => (
                  <Tag key={index} item={task} content={task.name} deleteFunction={() => deleteElement(task, "to_do", setTaks)} />
                ))}
              </div>
            </Card>

            <Card title="We offer">
              <ReferencedInputAndSubmit namedReference={weOfferRef} onClick={() => addElement(weOfferRef, "we_offer")} />
              <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {weOffer.map((offer, index) => (
                  <Tag key={index} item={offer} content={offer.name} deleteFunction={() => deleteElement(offer, "we_offer", setWeOffer)} />
                ))}
              </div>
            </Card>
          </div>

          {/* Sidebar */}
          <div>
            <Freelancers jobId={editJob.id} updateFreelancers={updateFreelancers} />
          </div>

        </div>
      </Content>
    </>
  ) : null;
};

export default Edit;
